<script>
  import { infer } from "./../utils/functions.js";
  import Container from "../shared/Container.svelte";
  import MobileMenu from "./MobileMenu.svelte";
  import { link } from "svelte-spa-router";
  import { onMount } from "svelte";
  import config from "../stores/config";
  import * as ls from "local-storage";
  import month from "../stores/month";

  let PWAInstallBtn;
  // let is_chrome = !!window.chrome;
  let is_chrome = false;
  let clickListener;

  $: DISPLAYER = infer($month.current);

  $: {
    if (PWAInstallBtn) {
      /*
        Attach the click event listener to the install button when it is shown,
        as on page load it's still hidden and waiting for the PWA to be ready. 
        The button will be rendered as soon as we have caught the beforeinstallprompt event.
        The event prompt will have to be manually triggered with the click of the button. 
        The beforeinstallprompt event will only trigger after the worker is installed, activated & ready.
        Otherwise it'll throw an exception and won't trigger.
      */
      PWAInstallBtn.addEventListener("click", clickListener);
    }
  }

  const handleLogout = () => {
    ls.remove("jwt");
    window.location.reload();
  };

  onMount(() => {
    window.onscroll = (e) => {
      scrollFunction();
    };

    const scrollFunction = () => {
      // let innerHeader = document.getElementById("inner-header");
      let header = document.getElementById("header");

      if (
        document.body.scrollTop > 30 ||
        document.documentElement.scrollTop > 30
      ) {
        // innerHeader.classList.replace("h-16", "h-12");
        header.classList.add("shadow-sm");
        header.classList.add("bg-brand-white");
      } else {
        // innerHeader.classList.replace("h-12", "h-16");
        header.classList.remove("shadow-sm");
        header.classList.remove("bg-brand-white");
      }
    };

    let deferredPrompt;

    window.addEventListener("beforeinstallprompt", (e) => {
      // Prevent the mini-infobar from appearing on mobile
      e.preventDefault();
      // Stash the event so it can be triggered later.
      deferredPrompt = e;
      // Update UI notify the user they can install the PWA
      // showInstallPromotion();
      // Show button when app can be installed, it can now be installed
      is_chrome = !!window.chrome;
    });

    clickListener = (e) => {
      // Hide the app provided install promotion on click
      // hideMyInstallPromotion();
      // Show the install prompt
      deferredPrompt.prompt();
      // Wait for the user to respond to the prompt
      deferredPrompt.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === "accepted") {
          console.log("User accepted the install prompt!");
        } else {
          console.log("User dismissed the install prompt!");
        }
      });
    };
  });
</script>

<div
  id="header"
  class="navbar text-gray-600 fixed top-0 left-0 w-full z-50 transition-all
    duration-250"
>
  <Container>
    <div
      id="inner-header"
      class="h-12 flex justify-between items-center transition-all duration-250"
    >
      <a class="nav-link flex items-center" use:link href="/">
        <img src="./favicon.png" class="w-8 object-cover mr-2" alt="home" />
      </a>

      <div class="hidden lg:flex lg:items-center">
        <a class="nav-link mr-8" use:link href="/">Acceuil</a>
        {#if $config.currentUser.role == "super-admin"}
          <!-- <a class="nav-link mr-8" use:link href="/admins">Administrators</a> -->
          <a class="nav-link mr-8" use:link href="/profile">Profile</a>
          <a class="nav-link mr-8" use:link href="/employees">Employés</a>
        {:else}
          <a class="nav-link mr-8" use:link href="/login">Connexion</a>
        {/if}
      </div>

      <div class="lg:flex lg:items-center">
        <div class="flex items-center">
          <button class="nav-link mr-2 lg:mr-0" on:click={handleLogout}>
            Quitter
          </button>
          <MobileMenu />
        </div>
      </div>
    </div>
  </Container>
</div>
